import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container ct-example-row mb-4 px-0" }
const _hoisted_2 = { class: "row flex-row mx-0" }
const _hoisted_3 = { class: "col-sm-12 col-md-6 mb-1" }
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "text-primary fas fa-phone" }, null, -1)
const _hoisted_6 = { class: "mx-3" }
const _hoisted_7 = { class: "text-dark font-weight-600 text-sm" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("small", { class: "d-block text-muted" }, " Número de teléfono ", -1)
const _hoisted_9 = { class: "col-sm-12 col-md-6 mb-1" }
const _hoisted_10 = { class: "d-flex align-items-center" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "text-primary fas fa-user" }, null, -1)
const _hoisted_12 = { class: "mx-3" }
const _hoisted_13 = { class: "text-dark font-weight-600 text-sm" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("small", { class: "d-block text-muted" }, " Nombre Completo ", -1)
const _hoisted_15 = { class: "col-sm-12 col-md-6 mb-1" }
const _hoisted_16 = { class: "d-flex align-items-center" }
const _hoisted_17 = { class: "mx-3" }
const _hoisted_18 = { class: "text-dark font-weight-600 text-sm" }
const _hoisted_19 = { class: "d-block text-muted" }
const _hoisted_20 = { class: "col-6" }
const _hoisted_21 = { class: "d-flex align-items-center" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-map-signs text-primary" }, null, -1)
const _hoisted_23 = { class: "mx-3" }
const _hoisted_24 = { class: "text-dark font-weight-600 text-sm" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("small", { class: "d-block text-muted" }, " Tipo de llamada ", -1)
const _hoisted_26 = { class: "col-6" }
const _hoisted_27 = { class: "d-flex align-items-center" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-people-arrows text-primary" }, null, -1)
const _hoisted_29 = { class: "mx-3" }
const _hoisted_30 = { class: "text-dark font-weight-600 text-sm" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("small", { class: "d-block text-muted" }, " Cola de llamada ", -1)

import { CallDataModule } from "@/store/modules/CallData";
import { computed } from "vue";
import { Field } from "@/types/components";
import { IndexType } from "@/types/store";
import { AppModule } from "@/store/modules/app";

// computed

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const form = computed<Field[]>(() => AppModule.userConfig?.data ?? []);
const loading = computed(() => {
	return CallDataModule.loadingSK;
});
const formView = computed(() =>
	form.value.filter(comp => !comp.hideOnView && comp.type !== "button")
);
const customer = computed<IndexType<string | number | object>>(() => {
	return {
		...(CallDataModule.user?.customer ?? {}),
		...CallDataModule.user?.dynamicData,
	};
});
const activeCall = computed(() => {
	return CallDataModule.activeCall;
});

// Methods
function printDataField(
	field: Field,
	data: IndexType<string | number | object>
) {
	return field.type === "options"
		? (data[field.name] as any)?.label ?? "Sin dato"
		: data[field.name] ?? "Sin dato";
}

return (_ctx: any,_cache: any) => {
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_scrollbar, { "max-height": "350px" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createVNode(_component_el_skeleton, {
                animated: "",
                rows: 1,
                loading: _unref(loading)
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("a", _hoisted_7, _toDisplayString(_unref(activeCall).call_number), 1),
                    _hoisted_8
                  ])
                ]),
                _: 1
              }, 8, ["loading"])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createVNode(_component_el_skeleton, {
                animated: "",
                rows: 1,
                loading: _unref(loading)
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("a", _hoisted_13, _toDisplayString(_unref(customer)["full_name"]), 1),
                    _hoisted_14
                  ])
                ]),
                _: 1
              }, 8, ["loading"])
            ])
          ]),
          _createVNode(_component_el_divider),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(formView), (field, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
              (!field.hidden || _unref(customer)[field.name])
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("i", {
                          class: _normalizeClass(["text-primary", field.icon])
                        }, null, 2),
                        _createVNode(_component_el_skeleton, {
                          animated: "",
                          rows: 1,
                          loading: _unref(loading)
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_17, [
                              _createElementVNode("a", _hoisted_18, _toDisplayString(printDataField(field as Field, _unref(customer))), 1),
                              _createElementVNode("small", _hoisted_19, _toDisplayString(field.label), 1)
                            ])
                          ]),
                          _: 2
                        }, 1032, ["loading"])
                      ])
                    ]),
                    ((index + 1) % 2 === 0)
                      ? (_openBlock(), _createBlock(_component_el_divider, { key: 0 }))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true)
            ], 64))
          }), 128)),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _createVNode(_component_el_skeleton, {
                animated: "",
                rows: 1,
                loading: _unref(loading)
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("a", _hoisted_24, _toDisplayString(_unref(activeCall)?.call_type?.length != 0
										? _unref(activeCall)?.call_type
										: "Sin dato"), 1),
                    _hoisted_25
                  ])
                ]),
                _: 1
              }, 8, ["loading"])
            ])
          ]),
          ((_unref(formView).length + 1) % 2 === 0)
            ? (_openBlock(), _createBlock(_component_el_divider, { key: 0 }))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _hoisted_28,
              _createVNode(_component_el_skeleton, {
                animated: "",
                rows: 1,
                loading: _unref(loading)
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("a", _hoisted_30, _toDisplayString(_unref(activeCall)?.queue?.length != 0 ? _unref(activeCall).queue : "Sin dato"), 1),
                    _hoisted_31
                  ])
                ]),
                _: 1
              }, 8, ["loading"])
            ])
          ])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})